// Mock data for Backflow Testing Website

export const companyInfo = {
  name: "PBNJ Backflow Testing",
  tagline: "Protecting Your Water Supply",
  phone: "(469) 505-4321",
  email: "info@pbnjbackflowtesting.com",
  address: "",
  hours: "Monday - Saturday: 9:00 AM - 7:00 PM"
};

export const services = [
  {
    id: 1,
    title: "Annual Backflow Testing",
    description: "State-certified testing to ensure your backflow prevention device is functioning properly and protecting your water supply.",
    features: [
      "Comprehensive device inspection",
      "Detailed test report",
      "Compliance certification",
      "Next day service available"
    ]
  },
  {
    id: 2,
    title: "Backflow Device Repair",
    description: "Expert repair services for all types of backflow prevention assemblies, ensuring compliance and safety.",
    features: [
      "Quick diagnosis",
      "Quality replacement parts",
      "Post-repair testing",
      "Warranty on repairs"
    ]
  },
  {
    id: 3,
    title: "Irrigation",
    description: "Professional testing and repair services for backflow prevention devices on irrigation and sprinkler systems.",
    features: [
      "Annual irrigation system testing",
      "Backflow preventer repair",
      "City compliance verification",
      "Licensed irrigator services"
    ]
  },
  {
    id: 4,
    title: "Same Day Service",
    description: "Premium same-day service with as little as 3 hours notice for urgent backflow testing needs and time-sensitive compliance requirements.",
    features: [
      "3-hour advance notice",
      "Priority scheduling",
      "Available Monday-Saturday",
      "Premium rate applies"
    ]
  }
];

export const pricingData = {
  testing: [
    { range: "1-4 devices tested", price: "$145.00 each" },
    { range: "5-10 devices tested", price: "$130.00 each" },
    { range: "11+ devices tested", price: "$115.00 each" }
  ],
  services: [
    { service: "Opening and cleaning", price: "$80.00 each" },
    { service: "Repair labor (3\" or smaller)", price: "$140.00 per hour" },
    { service: "Repair labor (4\" and larger)", price: "$250.00 per hour" }
  ],
  specialRates: [
    { type: "Annual domestic water", price: "$100.00" },
    { type: "New irrigation testing", price: "$100.00" }
  ],
  notes: [
    "Volume discounts apply to each trip out for testing",
    "Parts price varies depending on make, model and size",
    "City Fee varies by city, please ask for your city's fee"
  ]
};

export const serviceAreas = [
  "Arlington",
  "Bedford",
  "Carrollton",
  "Coppell",
  "Dallas",
  "Euless",
  "Farmers Branch",
  "Flower Mound",
  "Fort Worth",
  "Frisco",
  "Garland",
  "Grand Prairie",
  "Grapevine",
  "Haltom City",
  "Highland Park",
  "Hurst",
  "Irving",
  "Keller",
  "Lewisville",
  "Mansfield",
  "Mesquite",
  "North Richland Hills",
  "Plano",
  "Richardson",
  "Richland Hills",
  "Rowlett",
  "Southlake",
  "The Colony",
  "University Park",
  "Watauga"
];

export const whyChooseUs = [
  {
    title: "Certified Professionals",
    description: "All technicians are state-certified and trained in the latest backflow prevention standards."
  },
  {
    title: "Fast & Reliable",
    description: "We respect your time with prompt service and efficient testing procedures."
  },
  {
    title: "Compliance Guaranteed",
    description: "We ensure your property meets all local and state backflow prevention requirements."
  },
  {
    title: "Transparent Pricing",
    description: "No hidden fees. Clear, upfront pricing for all our services."
  }
];

export const aboutInfo = {
  story: "PBNJ Backflow Testing is dedicated to protecting communities' water supplies through professional backflow prevention services. Our team of certified specialists provides reliable testing and maintenance to ensure your water systems meet all regulatory standards.",
  mission: "Our mission is to safeguard public health by ensuring every backflow prevention device we test meets or exceeds regulatory standards. We believe clean, safe water is a fundamental right.",
  certifications: [
    "State Certified Backflow Tester",
    "TCEQ BPAT Certified",
    "Licensed Irrigator",
    "EPA WaterSense Partner",
    "Licensed & Fully Insured"
  ]
};
